<template>
  <div class="load-description">
    <div class="load-resume">
      <div class="load-resume__content" :class="selectedPlan === 'insurance' ? 'more-content' : ''">
        <div class="load-resume__left">
          <div class="load-locations">
            <p
              v-for="(label, type) in locationLabels"
              :key="type"
              style="margin: 0"
              v-html="getLocationsTextStyled($t(label), getStopName(type))"
            ></p>
          </div>
          <div class="load-information">
            <div class="load-name">
              <span v-if="quoteNumber"
                >{{ $t("carriers.quoteNumber") }}
                <p>{{ chosenLoad.name }}</p>
              </span>
            </div>
            <el-collapse v-model="accessorialsTab">
              <el-collapse-item :title="accessorialsCollapse" name="accessorials">
                <AccessorialsByType v-if="accessorials" :accessorials="accessorials " :chosenLoad="chosenLoad" />
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="lineItemsTabs">
              <el-collapse-item :title="lineItemsCollapse" name="lineItems">
                <InfoLineItems v-if="selectedLineItems" :selectedLineItems="selectedLineItems"
                :isDrayage="isDrayage" :loadById="chosenLoad"/>
              </el-collapse-item>
            </el-collapse>
            <div class="lineItems-information">
              <span v-if="!isDrayage">
                {{ $t("carriers.totalUnits") }}:
                <p class="lineItems-information__value">{{ handlingUnits }}</p>
              </span>
              <span v-else-if="isDrayage && carrierInfo.miles">
                {{ $t("carriers.miles") }}:
                <p class="lineItems-information__value">{{ carrierInfo.miles }}</p>
              </span>
            </div>
            <div id="edit-quote-wrapper">
              <button
                class="edit-quote--button"
                @click="changeView('QuoteBook')"
                :disabled="disableEditQuoteButton"
                :class="disableEditQuoteButton ? 'disabled' : ''"
                id="edit-quote-button"
              >
                <i class="ion ion-pencil-outline"></i>
                {{ $t("carriers.editQuoteDetails") }}
              </button>
            </div>
            <b-popover
              target="edit-quote-wrapper"
              triggers="hover"
              placement="top"
            >
            <div v-if="disableEditQuoteButton">
              {{ $t("carriers.editDrayageQuoteDisabledMessage") }}
            </div>
            </b-popover>
          </div>
        </div>
      </div>
      <div class="load-container-middle-view">
        <div class="load-resume__middle">
          <Markups v-if="isMagayaUser" :disableButtons="disableButtons" />
          <div class="selector-container">
            <span>Cargo insurance: Need additional coverage?</span>
            <CarrierPlanSelector
              @handleSelectedPlan="handleSelectedPlan"
              :loadingCargoValue="loadingCargoValue"
              :disableButtons="disableButtons"
              :cargoValue="cargoValue"
              :initialPlan="selectedPlan"
            />
            <div class="selector-container__info">
              <span>
                <i>{{ $t("carriers.messageVendorInsurance") }}</i>
              </span>
            </div>
          </div>
          <div
            class="cargo-value-container"
          >
            <CargoValue
              :disabledComponent="disableButtons"
              :cargoValueLoad="chosenLoad.cargo_value_for_insurance"
              :selectedPlan="selectedPlan"
              :invalidCargoValue="invalidCargoValue"
              v-model="cargoValue"
            />
            <el-button
              class="cargo-value__button"
              plain
              @click="calculateCargoValue"
              :disabled="areRequestInProcess || disableButtons"
            >
              <div class="cargo-value__content">
                <span v-if="!loadingCargoValue">
                  {{ $t("carriers.calculate") }}
                </span>
                <i
                  v-show="!loadingCargoValue"
                  class="ion ion-information-circle-outline"
                  id="popover-cargo-value"
                ></i>
                <b-spinner
                  small
                  v-if="loadingCargoValue"
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </div>
            </el-button>
            <b-popover target="popover-cargo-value" triggers="hover" placement="bottom">
              <template #title>{{ $t("carriers.insureShipment") }}</template>
              {{ $t("carriers.insureShipmentMessage") }}
            </b-popover>
          </div>
        </div>
        <div class="load-resume__right">
          <div class="quotes-file">
            <div id="download-quote-wrapper" v-if="$options.filters.checkPermission('get:quote-file')">
            <button
              class="quotes-file__button quotes-file__button--download"
              @click="openDownloadModal()"
              :class="(disableButtons || disableEditQuoteButton) ? 'disabled' : ''"
              :disabled="(disableButtons || disableEditQuoteButton)"
              v-if="$options.filters.checkPermission('get:quote-file')"
            >
              <span> Download quote file</span>
            </button>
            <b-popover target="download-quote-wrapper" triggers="hover" placement="top">
              <div v-if="disableEditQuoteButton">
                {{ $t("carriers.editDrayageQuoteDisabledMessage") }}
              </div>
            </b-popover>
          </div>

          <div id="send-quote-wrapper"
          v-if="$options.filters.checkPermission('post:quote-file') && tokenInfo.is_branded === false ">
            <button
              class="quotes-file__button"
              @click="openModal()"
              :class="(disableButtons || disableEditQuoteButton) ? 'disabled' : ''"
              :disabled="disableButtons || disableEditQuoteButton"
            >
              Send quote file
            </button>
            <b-popover target="send-quote-wrapper" triggers="hover" placement="top">
              <div v-if="disableEditQuoteButton">
                {{ $t("carriers.editDrayageQuoteDisabledMessage") }}
              </div>
            </b-popover>
          </div>
            <CustomModal
              v-model="formatDocumentModal"
              size="lg"
              :centered="true"
              :hide-header="true"
              :closeOnEsc="false"
              modalTitle="Download Quotes File"
              :showOverlay="loading"
            >
              <template #modal-content>
                <DownloadQuoteFilesModal
                  class="mt-3"
                  v-model="typeOfFormat"
                  :chosenLoad="chosenLoad"
                  :carriersList="carriersListCopy"
                  @closeModal="closeModal"
                  @handleLoading="handleLoading"
                />
              </template>
            </CustomModal>
            <b-modal
              v-model="showModal"
              hide-header
              hide-footer
              size="lg"
              no-close-on-backdrop
              centered
            >
              <SendQuoteFilesModal v-model="showModal" :carriersList="carriersListCopy" :chosenLoad="chosenLoad" />
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import onReSize from "@/Extend/onResize";
import UpdateAditionalInsurance from "@/utils/updateAditionalInsurance";
import Markups from "./Markups.vue";
import CarrierPlanSelector from "../../../../components/CarrierPlanSelector.vue";
import AccessorialsByType from "../../../../components/AccessorialsByType.vue";
import CustomModal from "../../../../components/CustomModal.vue";
import InfoLineItems from "../../../../components/LineItems.vue";
import CargoValue from "./CargoValue.vue";
import SendQuoteFilesModal from "./SendQuoteFilesModal.vue";
import modes from "../../modes";
import DownloadQuoteFilesModal from "./DownloadQuoteFilesModal.vue";
import FormatEasyPostPrices from '../../../../Extend/FormatEasyPostPrices';
import FilterEasyPostCarriers from '../../../../Extend/FilterEasyPostCarriers';

export default {
  name: "LoadResume",
  props: {
    chosenLoad: Object,
    quoteNumber: Boolean,
    disableButtons: Boolean,
    areRequestInProcess: Boolean,
  },
  components: {
    Markups,
    CargoValue,
    AccessorialsByType,
    InfoLineItems,
    SendQuoteFilesModal,
    CustomModal,
    DownloadQuoteFilesModal,
    CarrierPlanSelector,
  },
  mixins: [onReSize, FormatEasyPostPrices, FilterEasyPostCarriers],
  data() {
    return {
      screenWidth: null,
      quoteType: null,
      accessorials: null,
      accessorialsCollapse: null,
      lineItemsCollapse: null,
      accessorialsTab: [],
      lineItemsTabs: [],
      selectedLineItems: null,
      cargoValue: null,
      initialCargoValueForInsurance: null,
      invalidCargoValue: false,
      loadingCargoValue: false,
      planSwitchLoadingTimeoutId: null,
      handlingUnits: 0,
      totalWeight: 0,
      showModal: false,
      loading: false,
      tokenInfo: null,
      formatDocumentModal: false,
      typeOfFormat: "",
      selectedPlan: "",
      isMagayaUser: null,
      carriersListCopy: [],
    };
  },
  async created() {
    this.tokenInfo = this.$store.getters["login/getTokenInfo"];
    this.isMagayaUser = this.$store.getters["login/getTokenInfo"].magaya_guid;
    this.cargoValue = this.getCargoValueFromChosenLoad();
    this.initialCargoValueForInsurance = this.cargoValue;
    this.$store.commit("carriers/setChosenLoadCargoValue", this.cargoValue);
    this.selectedPlan = this.derivePlanFromCargoValue(this.cargoValue);
    this.$store.commit("carriers/setInsuranceCoveragePlan", this.selectedPlan);
    if (this.chosenLoad.multiservice) {
      this.quoteType = "all-options";
    } else {
      const modeId = this.chosenLoad.mode_id;
      const modesKeys = Object.keys(modes);
      this.quoteType = modesKeys.find((key) => modes[key].modeId === modeId);
    }
    this.selectedLineItems = this.chosenLoad.line_items;
    this.accessorials = this.chosenLoad.accessorials;
    this.collapseInformation();
  },
  beforeDestroy() {
    this.$store.commit("carriers/setChosenLoadCargoValue", false);
    this.$store.commit("carriers/clearCarriers");
  },
  computed: {
    ...mapGetters({
      loadWasInsured: "load/getLoadWasInsured",
      carriersList: "carriers/getCarriers",
      drayageCarriers: "drayage/getCarrierInfo",
      carrierInfo: "drayage/getCarrierInfo",
    }),
    isDrayage() {
      return this.chosenLoad?.mode_name.toLowerCase() === 'drayage';
    },
    watchedCarriers() {
      if (this.isDrayage && this.drayageCarriers) {
        return [{
          ...this.drayageCarriers
        }];
      }
      return this.carriersList;
    },
    disableEditQuoteButton() {
      return this.isDrayage && !this.chosenLoad.origin_portal_quote;
    },
    locationLabels() {
      return {
        is_pickup: this.isDrayage ? 'carriers.originDrayage' : 'carriers.origin',
        is_dropoff: this.isDrayage ? 'carriers.destinationDrayage' : 'carriers.destination'
      };
    }
  },
  watch: {
    cargoValue(value) {
      const n = Number(value);
      const normalized = Number.isFinite(n) ? n : 0;
      this.$store.commit("carriers/setChosenLoadCargoValue", normalized);
      this.safeSetCargoValueToLocalStorage(normalized);
    },
    watchedCarriers: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.isDrayage) {
          this.carriersListCopy = newVal;
        } else {
          this.carriersListCopy = this.filterAndMergeEasyPostCarriers(newVal);
        }
        this.originalCarrierArray = [...newVal];
      }
    },
  },
  methods: {
    getCargoValueFromChosenLoad() {
      const nestedValue = this.chosenLoad?.load?.cargo_value_for_insurance;
      if (nestedValue !== null && nestedValue !== undefined) return nestedValue;
      return this.chosenLoad?.cargo_value_for_insurance;
    },
    derivePlanFromCargoValue(value) {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return "minimum";
      if (n <= 15000) return "minimum";
      if (n <= 25000) return "basic";
      return "insurance";
    },
    startPlanSwitchLoading() {
      if (this.loadingCargoValue) return;
      if (this.planSwitchLoadingTimeoutId) {
        clearTimeout(this.planSwitchLoadingTimeoutId);
      }
      this.loadingCargoValue = true;
      this.planSwitchLoadingTimeoutId = setTimeout(() => {
        this.loadingCargoValue = false;
        this.planSwitchLoadingTimeoutId = null;
      }, 450);
    },
    addDropOffEasypostCarriers() {
      this.carriersListCopy.forEach((element) => {
        if (element.source === "easy-post" && (element.scac === "UPSN" || element.scac === "FDEG")) {
          const copyCarrier = { ...element };
          copyCarrier.carrier = `${element.carrier} (PICKUP)`;
          copyCarrier.price = this.formatEasyPostPriceWithPickup(copyCarrier);
          this.carriersListCopy.push(copyCarrier);
        }
      });
    },
    getStopName(stopType) {
      const stopData = this.chosenLoad.stops.find((stop) => stop[stopType]);
      if (!stopData.location_id) {
        return `${stopData.city},
          ${stopData.state_code} ${stopData.zip_code}`;
      }
      const stopName = this.chosenLoad.accounts.find(
        (item) => item.id === stopData.location_id
      ).name;
      return `${stopName} - ${stopData.address}`;
    },
    collapseInformation() {
      this.accessorialsCollapse = ` ${this.$t("carriers.accessorials")} (${
        this.accessorials.length
      })`;
      this.lineItemsCollapse = `${this.$t("carriers.lineItems")} (${
        this.selectedLineItems.length
      })`;
      this.selectedLineItems.forEach((el) => {
        this.handlingUnits += parseInt(el.handling_unit_count, 10);
      });
      this.selectedLineItems.forEach((el) => {
        this.totalWeight += parseInt(el.weight, 10);
      });
    },
    async calculateCargoValue() {
      this.invalidCargoValue = false;
      const n = Number(this.cargoValue);
      const currentCargoValue = Number.isFinite(n) ? n : 0;
      if (currentCargoValue < 0) {
        this.invalidCargoValue = true;
        return;
      }
      if (this.selectedPlan === "insurance" && currentCargoValue <= 0) {
        this.invalidCargoValue = true;
        return;
      }
      this.loadingCargoValue = true;
      this.$emit("handlingAreRequestInProcess", true);
      const fee = UpdateAditionalInsurance(currentCargoValue, this.selectedPlan);
      const initial = Number(this.initialCargoValueForInsurance);
      const initialCargoValue = Number.isFinite(initial) ? initial : 0;
      const body = {
        cargocare_insurance_selling_rate_amount: fee,
        ...(currentCargoValue !== initialCargoValue && {
          cargo_value_for_insurance: currentCargoValue || null,
        }),
      };
      await this.$store.dispatch("load/updateLoad", {
        id: this.$route.params.loadId,
        body,
      });
      if (body.cargo_value_for_insurance !== undefined) {
        this.$store.commit("load/updateCargoValue", currentCargoValue);
        this.initialCargoValueForInsurance = currentCargoValue;
      }
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "cargocare_insurance_selling_rate_amount",
        value: fee,
      });
      this.$emit("handlingAreRequestInProcess", false);
      this.$store.commit("transportSelected/modifyTransportModalInformation", {
        key: "insurance",
        value: currentCargoValue,
      });
      this.$store.commit("carriers/setChosenLoadCargoValue", currentCargoValue);
      this.safeSetCargoValueToLocalStorage(currentCargoValue);
      this.$store.commit("load/setLoadInsurance", true);
      this.loadingCargoValue = false;
      this.openUpdatingPricesNotification();
    },
    safeSetCargoValueToLocalStorage(value) {
      try {
        localStorage.setItem("cargoValue", JSON.stringify(value || 0));
        return true;
      } catch (e) {
        return false;
      }
    },
    openUpdatingPricesNotification() {
      this.$notify({
        title: "Success",
        message: "Rates have been updated",
        type: "success",
      });
    },
    changeView(routeName) {
      this.$store.commit("carriers/disconnectSocket");
      this.$store.commit("carriers/resetCarriersList");
      this.$router
        .push({
          name: routeName,
          params: {
            quoteType: this.quoteType,
            loadId: this.$route.params.loadId,
            comesFromCarriers: true,
          },
        })
        .catch((error) => {
          if (error.name !== "NavigationDuplicated") {
            throw error;
          }
        });
    },
    openModal() {
      this.showModal = true;
    },
    openDownloadModal() {
      this.formatDocumentModal = true;
    },
    closeModal() {
      this.formatDocumentModal = false;
    },
    handleLoading(data) {
      this.loading = data;
      this.$emit("handlingAreRequestInProcess", data);
    },
    getLocationsTextStyled(title, text) {
      const textHtml = `<strong>${title}</strong> ${text}`;
      return textHtml;
    },
    async handleSelectedPlan(plan) {
      this.selectedPlan = plan;
      this.$store.commit("carriers/setInsuranceCoveragePlan", plan);
      this.startPlanSwitchLoading();
      if (plan !== "insurance") {
        this.invalidCargoValue = false;
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../assets/scss/components/Modal.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/buttons/_buttons' as *;

.load-description {
  color: $color-primary-company;
  font-family: $font-family-portal;
  margin: 20px auto;
  padding-bottom: 15px;
  margin-bottom: 0px;
}

.load-container-middle-view {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  max-width: 820px;
  .load-resume__right {
    width: 100%;
  }
  @media (width <= 1630px) {
    width: 100%;
  }
  @media (max-width: 800px) {
    max-width: none;
  }
}

.load-resume {
  width: 100%;
  color: $color-primary-company;
  font-weight: bold;
  text-align: left;
  display: flex;
  justify-content: space-between;
  // flex-wrap: wrap;
  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
  &__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
    width: 100%;
    height: auto;
    min-height: 265px;
    align-items: start;
    @media (max-width: 810px) {
      align-items: start;
      height: auto;
      flex-direction: column;
      position: inherit;
    }
  }
  &__left {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    overflow-wrap: break-word;
    width: 98%;
    @media (max-width: 810px) {
      width: 100%;
      max-width: none;
    }
    span {
      display: flex;
      @media (max-width: 300px) {
        display: flex;
        flex-direction: column;
      }
    }
    p {
      margin-left: 5px;
      margin-bottom: 4px;
      font-weight: 400;
    }
  }
  &__middle {
    width: 100%;
    min-width: 0;
    @media (max-width: 800px) {
      margin-bottom: 5px;
      width: 100%;
    }
  }
  &__right {
    display: flex;
    flex-direction: column;
    width: 40%;
    @media (max-width: 810px) {
      position: inherit;
      width: 100%;
    }
  }
}
.load-information {
  max-width: 470px;
  @media (max-width: 810px) {
    width: 100%;
    max-width: none;
  }
}
.load-resume .more-content {
  min-height: 292px;
}
@media (max-width: 1203px) {
  .load-resume .more-content {
    min-height: 335px;
    align-items: flex-start;
    @media (max-width: 810px) {
      align-items: start;
      height: auto;
    }
  }
}
.selector-container span {
  font-weight: bold;
  font-family: $font-family-portal;
}

.selector-container{
  &__info{
    font-family: $font-family-portal;
    font-size: 14px;
  }
}

.load-locations {
  @media (max-width: 810px) {
    padding-right: 0px;
    width: 100%;
  }
  p {
    margin-left: 5px;
    margin-bottom: 4px;
    font-weight: 400;
  }
}

.load-name {
  display: none;
  @media (max-width: 500px) {
    display: contents;
  }
}

.edit-quote--button {
  width: 280px;
  margin-top: 10px;
  border: none;
  color: $color-white;
  background: $color-primary-trigger-button;
  border-radius: 15px;
  height: 35px;
  @include font-small-button-text;
  &:hover {
    background-color: $color-primary-trigger-button-hover;
  }
  @media (max-width: 800px) {
    width: 100%;
  }
  &.disabled {
    background-color: $color-gray;
    cursor: not-allowed;
  }
}

.cargo-value {
  &__content {
    display: flex;
    align-items: center;
  }
}

.invalid-cargo-value {
  color: red;
  margin: 0;
  padding: 0;
  font-size: 10px;
  margin-left: 10px;
  &__input {
    background: rgb(253, 234, 234);
  }
}

.quotes-file {
  width: 100%;
  display: flex;
  flex-direction: column;
  &__button {
    @include secondary-button;
    height: 35px;
    margin: 10px auto 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    font-size: 13px;
    font-weight: 600;
    &--download {
      @include primary-button(35px);
      width: 100%;
      margin: 10px auto 0px;
    }
  }
  & .disabled {
    background-color: $color-gray;
    border: none;
    color: $color-white;
    &:hover {
      background-color: $color-gray;
    }
  }
}

.lineItems-information {
  span {
    margin: 2px 0;
  }
}
::v-deep {
  .el-collapse-item__wrap {
    border: none;
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  .el-collapse-item__header {
    background-color: rgb(246 246 246);
    font-family: $font-family-portal;
    color: $color-primary-company;
    @include font-standart-text;
    width: 100%;
    text-align: left;
    font-weight: bold;
    height: 30px;
    border: none;
  }
  .el-collapse-item__content {
    background-color: $color-background;
    font-family: $font-family-portal;
    @include font-standart-text;
    font-weight: normal;
    padding-bottom: 0%;
  }
  .row-accessorials__information {
    margin-left: 10px;
  }
  .el-icon-arrow-right:before {
    padding: 10px;
    color: $color-primary-company;
    font-weight: bold;
  }
  .el-icon-arrow-right:after {
    padding: 10px;
    color: $color-primary-company;
    font-weight: bold;
  }
  .ion-information-circle-outline {
    font-size: 1.2rem;
    margin-left: 10px;
  }
  .popover-header {
    font-family: $font-family-portal;
    color: $color-primary-company;
    font-size: 12px;
    font-weight: bold;
  }
  .popover-body {
    font-family: $font-family-portal;
    color: $color-primary-company;
    font-size: 12px;
  }
  .el-button,
  .el-button.is-plain {
    @include primary-button();
    height: 35px;
    margin: 10px auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    @include font-small-button-text;
  }
}

@media (max-width: 1630px) {
  .load-resume {
    // flex-direction: column;
    &__left {
      max-width: none;
    }
  }
  .load-container-middle-view {
    justify-content: inherit;
  }
}

@media (max-width: 800px) {
  .load-resume {
    &__middle {
      width: 100%;
    }
    &__right {
      width: 100% !important;
    }
  }
  .load-container-middle-view {
    flex-direction: column;
  }
  .quotes-file {
    width: 100%;
  }
}

</style>
